import { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "@/config/antd";
import { useNavigate } from "react-router-dom";
import Avatar from "@/components/common/Avatar";
import AttendeeCard from "@/pages/event_management/single_campaign/components/attendees_tabs/Attendee_Card";

const AttendeesTab = ({ attendees }) => {
  const [isViewAllOpen, setIsViewAllOpen] = useState(false);
  const navigate = useNavigate();

  // Function to handle navigation to user profile
  const navigateToProfile = (attendeeId) => {
    navigate(`/dashboard/users/${attendeeId}`);
  };

  // Pass through profile image; AttendeeCard / Avatar handles the global dummy fallback
  const getProfileImage = (attendee) => attendee.profileImage || null;

  // Open view all modal
  const handleViewAll = () => {
    setIsViewAllOpen(true);
  };

  if (!attendees?.length) {
    return (
      <div className="text-center text-gray-500 py-4">
        No attendees found for this town hall
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-darkGrey">
          Attendees ({attendees.length})
        </h3>
        <Button
          type="link"
          className="text-primary font-bold"
          onClick={handleViewAll}>
          VIEW ALL
        </Button>
      </div>

      <div className="space-y-4">
        {attendees.map((attendee) => (
          <AttendeeCard
            key={attendee._id}
            attendee={{
              id: attendee._id,
              name: attendee.fullname,
              avatar: getProfileImage(attendee),
              confirmed: true,
              username: attendee.username || attendee.fullname,
            }}
            onClick={() => navigateToProfile(attendee._id)}
          />
        ))}
      </div>

      {/* View All Attendees Modal */}
      <Modal
        open={isViewAllOpen}
        onCancel={() => setIsViewAllOpen(false)}
        footer={null}
        centered
        width={800}
        title="All Attendees">
        <div className="max-h-[500px] overflow-y-auto p-4">
          {!attendees || attendees.length === 0 ? (
            <div className="text-center py-4">
              No attendees found for this town hall
            </div>
          ) : (
            <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-4">
              {attendees.map((attendee, index) => (
                <div
                  key={attendee?._id || index}
                  className="flex flex-col items-center">
                  <div
                    className="cursor-pointer"
                    onClick={() => navigateToProfile(attendee._id)}>
                    <Avatar
                      src={getProfileImage(attendee)}
                      alt={attendee.fullname || "Attendee"}
                      size={64}
                      className="cursor-pointer"
                    />
                  </div>
                  <p className="mt-2 text-small font-medium text-center text-gray-800">
                    {attendee.fullname?.split(" ")[0] ||
                      attendee.username ||
                      "Unknown"}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

AttendeesTab.propTypes = {
  attendees: PropTypes.array,
};

export default AttendeesTab;
